module.exports = __webpack_public_path__ + "img/0103.4f4c00e5.png";